// 财税检测
export default [
  {
    path: "/inspection",
    name: "inspection",
    component: () => import("@/views/inspectionNav/inspectionNav.vue"),
    meta: {
      title: "财税检测",
    },
  },
];
